// This file was automatically generated from ptdata.ptProblems.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.ptProblems');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.imo');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.documentedAsNoneSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('No known problems');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.year), ' ');
  el8.template.ptdata.ptProblems.summaryNoYear(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.description));
  if (opt_data.withCodes && opt_data.imos.length) {
    output.append(' [');
    el8.template.appshared.imo.rawImoList({imos: opt_data.imos, icd10Only: true}, output);
    output.append(']');
  }
  output.append((opt_data.withDetails && opt_data.details) ? '\n> ' + soy.$$escapeHtml(opt_data.details) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.summaryNoYear = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.description), (opt_data.status == 'Resolved') ? ' -- resolved' + ((opt_data.resolvedDate) ? ' on ' + (soy.$$escapeHtml(opt_data.resolvedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.resolvedDate)) : '') : '') : '', (opt_data.details) ? '<p class="el8SubText"><i>' + soy.$$escapeHtml(opt_data.details) + '</i></p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.detailedDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8ProblemDescription ', (opt_data.nonImoIcd9Codes.length && ! opt_data.imos.length) ? 'el8ProblemNeedsXWalk' : '', '"', (opt_data.isDxOutdated) ? 'title="Problem may contain non-billable or deprecated DX code(s)"' : '', '>', (opt_data.nonImoIcd9Codes.length && ! opt_data.imos.length) ? '<span class="el8FeedItemNewMarker mr5"></span>' : '', (opt_data.isDxOutdated) ? '<span class="el8CodeInvalidDot mr5"></span>' : '', soy.$$escapeHtml(opt_data.description), '</span> <span class="el8CodeSmaller">', (opt_data.imos.length || opt_data.nonImoIcd9Codes.length) ? '[' : '');
  if (opt_data.hccScoringEnabled) {
    el8.template.appshared.imo.imoList({imos: opt_data.imos, showHcc: true, icd10Only: opt_data.showDualCodingDisabled && ! opt_data.needsXWalk}, output);
  } else {
    el8.template.appshared.imo.imoList({imos: opt_data.imos, icd10Only: opt_data.showDualCodingDisabled && ! opt_data.needsXWalk}, output);
  }
  if (! opt_data.showDualCodingDisabled || opt_data.needsXWalk) {
    output.append((opt_data.imos.length && opt_data.nonImoIcd9Codes.length) ? ', ' : '');
    var codeList22186 = opt_data.nonImoIcd9Codes;
    var codeListLen22186 = codeList22186.length;
    for (var codeIndex22186 = 0; codeIndex22186 < codeListLen22186; codeIndex22186++) {
      var codeData22186 = codeList22186[codeIndex22186];
      output.append(soy.$$escapeHtml(codeData22186), (! (codeIndex22186 == codeListLen22186 - 1)) ? ', ' : '');
    }
  }
  output.append((opt_data.imos.length || opt_data.nonImoIcd9Codes.length) ? ']' : '', '</span>', (opt_data.hccScoringEnabled) ? (opt_data.isShowLastFullyAddressedDate) ? '<br /><span class="el8LastAddressedDate">Last addressed: ' + ((opt_data.lastFullyAddressedDate) ? soy.$$escapeHtml(opt_data.lastFullyAddressedDate) : 'Never') + '</span>' : '' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptProblems.detailedDescriptionWithResolvedStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.ptProblems.detailedDescription(opt_data, output);
  output.append((opt_data.status == 'Resolved') ? ' <span class="el8SystemText">-- resolved' + ((opt_data.resolvedDate) ? ' on ' + (soy.$$escapeHtml(opt_data.resolvedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.resolvedDate)) : '') : '') + '</span>' : '');
  if (!opt_sb) return output.toString();
};
